import React, { useMemo } from 'react'
import { Box } from '@mui/material'
import { ProductGroup } from 'hooks/useAllProducts'
import { Product } from 'hooks/useProduct'
import ProductItem from 'pages/Cabinets/ProductItem'

type ProductListProps = {
  allProducts: ProductGroup
  selectedItemCategory: string | null
  selectedCabinetType: string | null
}

const FilteredProductList: React.FC<ProductListProps> = ({
  allProducts,
  selectedItemCategory,
  selectedCabinetType
}) => {
  const filteredProducts = useMemo(() => {
    if (!allProducts || Object.keys(allProducts).length === 0) return []

    const uniqueProductsMap = new Map<string, Product>()

    Object.values(allProducts).forEach(classGroup =>
      Object.values(classGroup).forEach(colorGroup =>
        Object.values(colorGroup).forEach(itemCategoryGroup =>
          Object.values(itemCategoryGroup).forEach(cabinetTypeGroup =>
            cabinetTypeGroup.forEach(product => {
              if (product.id && !uniqueProductsMap.has(product.id)) {
                uniqueProductsMap.set(product.id, product)
              }
            })
          )
        )
      )
    )

    let products = Array.from(uniqueProductsMap.values())

    if (selectedItemCategory) {
      products = products.filter(
        product =>
          Array.isArray(product.itemCategory) &&
          product.itemCategory.includes(selectedItemCategory)
      )
    }

    if (selectedCabinetType) {
      products = products.filter(
        product => product.cabinetType === selectedCabinetType
      )
    }

    return products
  }, [allProducts, selectedItemCategory, selectedCabinetType])

  if (filteredProducts.length === 0) return null

  const groupedByCabinetType: { [cabinetType: string]: Product[] } = {}

  filteredProducts.forEach(product => {
    const cabinetType = product.cabinetType
    if (!groupedByCabinetType[cabinetType]) {
      groupedByCabinetType[cabinetType] = []
    }
    groupedByCabinetType[cabinetType].push(product)
  })

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        width: '100%'
      }}
    >
      {Object.entries(groupedByCabinetType).map(
        ([cabinetType, products], index) => (
          <Box key={`${cabinetType}-${index}`} sx={{ padding: '16px' }}>
            <ProductItem cabinetTypeKey={cabinetType} itemData={products} />
          </Box>
        )
      )}
    </Box>
  )
}

export default FilteredProductList
